import React from "react";
import styles from "./DpScheduledPatientInfo.module.scss";
import { FemaleIcon} from "../../../assets";
import {InfoText} from "../../../shared";
import moment from "moment/moment";

const DpScheduledPatientInfo = ({br}) => {
  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        <FemaleIcon className='mr-5'/>
        <div className={styles.title} >Данные о пациенте</div>
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'Пациент'} text={br?.patient_name || br?.name}/>
        <InfoText className={styles.dcText} title={'Дата Рождения'} text={`${moment(br?.birthday).format('DD/MM/YYYY')}`}/>
        <InfoText className={styles.dcText} title={'Город'} text={br?.city}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcTextComplaints} title={'Дата вызова'} text={`${moment(br?.scheduled_date).format('DD/MM/YYYY')}`}/>
        <InfoText className={styles.dcTextComplaints} title={'Время прибытия'} text={br?.time}/>
        <InfoText className={styles.dcTextComplaints} title={'Телефон'} text={`+7${br?.contact_number}`}/>
      </div>
     <div className={styles.wrapper}>
       {br?.station_info &&  <InfoText className={styles.dcTextComplaints} title={'Название стационара'} text={br?.station_info}/>}
        <InfoText className={styles.dcTextComplaints} title={'Адрес'} text={br?.address}/>

      </div>
      <div className={styles.wrapper}>
        {br?.data?.diagnose && <InfoText className={styles.dcTextComplaints} title={'Диагноз'} text={br?.data?.diagnose}/>}
        <InfoText className={styles.dcTextComplaints} title={'Повод обращения'} text={br?.data?.request_reason}/>
        <InfoText className={styles.dcTextComplaints} title={'Профиль бригады'} text={br?.data?.brigade_type}/>
      </div>
      <div className={styles.wrapper}>
        {br?.data?.severity && <InfoText className={styles.dcTextComplaints} title={'Тяжесть состояния'} text={br?.data?.severity}/>}
        {br?.data?.additional && <InfoText className={styles.dcTextComplaints} title={'Дополнительная информация'}
                   text={br?.data?.additional}/>}
        {br?.data?.weight && <InfoText className={styles.dcTextComplaints} title={'Вес больного (кг)'} text={br?.data?.weight}/>}
      </div>
      <div className={styles.wrapper}>
        {<InfoText className={styles.dcTextComplaints} title={'Наличие лифта'} text={br?.data?.elevator ? "Да" : "Нет"}/>}
        {<InfoText className={styles.dcTextComplaints} title={'Грузовой лифт'}
                   text={br?.data?.freight ? "Да" : "Нет"}/>}
        {br?.data?.floor && <InfoText className={styles.dcTextComplaints} title={'Этаж'} text={br?.data?.floor}/>}
        {br?.data?.appartment && <InfoText className={styles.dcTextComplaints} title={'Квартира'} text={br?.data?.appartment}/>}
      </div>

      {/*<div className={styles.wrapper}>*/}
      {/*  /!*<InfoText className={styles.dcText} title={'Запрос госпитализации'} text={br?.need_hospitalization ? "Да" : "Нет"}/>*!/*/}
      {/*</div>*/}
      {br?.data?.need_hospitalization &&
        <div className={styles.wrapper}>
          <InfoText className={styles.dcText} title={'Название стационара'} text={br?.station_info }/>
          <InfoText className={styles.dcText} title={'Адрес стационара'} text={br?.station_info_address}/>
        </div>
      }
    </div>
  </div>
}

export default DpScheduledPatientInfo
